import React, { useEffect } from 'react';
import { useInvokeApi } from '../../utils/useInvokeApi';
import { useParams } from 'react-router-dom';
import LoadingBar from 'theme/components/LoadingBar';
import ErrorPage from './ErrorPage';
import View from './view';

const AcceptInvite = () => {
    const { token = '' } = useParams<{ token: string }>();
    const [response, makeRequest] =
        useInvokeApi<{ officialFirstName: string }>();

    useEffect(() => {
        makeRequest('GET', `/invite/activation/${token}`);
    }, [token, makeRequest]);

    if (response.type === 'REQUEST_INIT' || response.type === 'REQUEST_START')
        return <LoadingBar show />;

    if (response.type === 'REQUEST_ERROR')
        return <ErrorPage code={response.error.response?.status} />;

    return <View name={response.data.officialFirstName} token={token} />;
};

export default AcceptInvite;
